var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fm-loader-fade" } }, [
    _vm.loading
      ? _c(
          "div",
          { staticClass: "fm-loader", class: { "fm-loader--dim": _vm.dim } },
          [
            _c("div", { staticClass: "fm-loader__card" }, [
              _c("div", { staticClass: "fm-loader__badge" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "34",
                      height: "34",
                      viewBox: "0 0 24 24",
                      fill: "currentColor",
                      "aria-hidden": "true",
                    },
                  },
                  [
                    _c("path", {
                      attrs: { d: "M13 2L3 14h9l-1 8 10-12h-9l1-8z" },
                    }),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("h1", { staticClass: "fm-loader__title" }, [
                _vm._v("Flash Money"),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "fm-loader__sub" }, [
                _vm._v(_vm._s(_vm.message)),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "fm-loader__track",
                  attrs: { role: "progressbar", "aria-label": "Loading" },
                },
                [_c("div", { staticClass: "fm-loader__fill" })]
              ),
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "fm-loader__legal" }, [
              _vm._v("Australian Credit Licence 508661"),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }